import * as yup from 'yup'

export const adminEditSocietyWebsiteSchema = yup
  .object({
    slug: yup.string().required(),
    displayName: yup.string().required(),
    displayCityState: yup.string().required(),
  })
  .required()
